var _g, _g2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaintenanceBand = function SvgMaintenanceBand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 249,
    fill: "none",
    viewBox: "0 0 320 249"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#maintenance-band_svg__a)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 160,
    cy: 124.5,
    fill: "url(#maintenance-band_svg__b)",
    fillOpacity: 0.6,
    rx: 85,
    ry: 34.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#maintenance-band_svg__c)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5FD4D4",
    fillOpacity: 0.17,
    d: "M319 84.23c0 14.04-71.411 25.42-159.5 25.42C71.41 109.65 0 98.27 0 84.23v73c0-14.038 71.41-25.419 159.5-25.419 88.089 0 159.5 11.381 159.5 25.419z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5FD4D4",
    fillOpacity: 0.25,
    d: "M320 97.23c0 8.847-71.411 16.018-159.5 16.018-88.09 0-159.5-7.171-159.5-16.017v45.999c0-8.846 71.41-16.017 159.5-16.017 88.089 0 159.5 7.171 159.5 16.017z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#47C2BF",
    d: "M320 107.23c0 5.001-71.411 9.054-159.5 9.054-88.09 0-159.5-4.053-159.5-9.054v26c0-5 71.41-9.053 159.5-9.053 88.089 0 159.5 4.053 159.5 9.053z",
    opacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "maintenance-band_svg__a",
    width: 350,
    height: 249,
    x: -15,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5003_77169",
    stdDeviation: 45
  })), /*#__PURE__*/React.createElement("filter", {
    id: "maintenance-band_svg__c",
    width: 331.464,
    height: 85.464,
    x: -6.232,
    y: 77.998,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5003_77169",
    stdDeviation: 3.116
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "maintenance-band_svg__b",
    x1: 160,
    x2: 160,
    y1: 90,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46CEB5"
  })))));
};
export default SvgMaintenanceBand;